<div class="row d-flex p-1 align-items-center">
    <div class="col-8 firstcol text-truncate">{{organisationWorkgroup.name}}</div>
    <div class="col-2">{{organisationWorkgroup.members}}</div>
    <div class="col-2 text-end">
        <div class="btn-group">
            <button type="button" class="btn btn-sm bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
            </button>
            <ul class="dropdown-menu">
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Edit" (click)="dialogWorkgroup('edit')"></a></li>
                <li><a class="dropdown-item pt-1 pb-1" translate="Button.Delete" (click)="deleteWorkgroup()" placement="top" ngbTooltip="{{'Settings.OrganisationWorkgroupsSection.DeleteWorkgroupTooltip' | translate}}" [openDelay]="500" [closeDelay]="500"></a></li>
            </ul>
        </div>
    </div>
</div>